import { render, staticRenderFns } from "./AutoIdCardInput.vue?vue&type=template&id=54acbcaa&scoped=true&"
import script from "./AutoIdCardInput.vue?vue&type=script&lang=js&"
export * from "./AutoIdCardInput.vue?vue&type=script&lang=js&"
import style0 from "./AutoIdCardInput.vue?vue&type=style&index=0&id=54acbcaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54acbcaa",
  null
  
)

export default component.exports